const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                if (!!(!!(!!((context.has(`columns`) ? context.get(`columns`) : null) && ((context.has(`columns`) ? context.get(`columns`) : null) > 1)) && (context.has(`columnsBreakpoint`) ? context.get(`columnsBreakpoint`) : null)) && !this.compare((context.has(`columnsBreakpoint`) ? context.get(`columnsBreakpoint`) : null), `none`))) {
                    this.echo(`  `);
                    context.proxy[`_deck_class`] = (((((((`o-deck--` + (context.has(`columns`) ? context.get(`columns`) : null)) + `-column`) + (context.has(`columnsBreakpoint`) ? context.get(`columnsBreakpoint`) : null)) + ` `) + (context.has(`class`) ? context.get(`class`) : null)) + ` `) + (context.has(`alignment`) ? context.get(`alignment`) : null));
                }
                else {
                    this.echo(`  `);
                    context.proxy[`_deck_class`] = (((context.has(`class`) ? context.get(`class`) : null) + ` `) + (context.has(`alignment`) ? context.get(`alignment`) : null));
                }
                this.echo(`
`);
                this.echo(this.include(context, this.source, this.loadTemplate(`e968fcb08ec832e1a1295316e3e5c05881627562090baf8760cd67f88b5cf595`, `e968fcb08ec832e1a1295316e3e5c05881627562090baf8760cd67f88b5cf595`, 7, 23), new Map([[`class`, (context.has(`_deck_class`) ? context.get(`_deck_class`) : null)]]), true, false, 7));
            }

            getTemplateName() {
                return `e968fcb08ec832e1a1295316e3e5c05881627562090baf8760cd67f88b5cf595`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e968fcb08ec832e1a1295316e3e5c05881627562090baf8760cd67f88b5cf595`, ``);
            }
        }],
        [23, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/deck/deck.twig`, `e968fcb08ec832e1a1295316e3e5c05881627562090baf8760cd67f88b5cf595`, 7);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/deck/deck.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(this.createRange(1, 3));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                context.set('loop', new Map([
                  ['parent', context.get('_parent')],
                  ['index0', 0],
                  ['index', 1],
                  ['first', true]
                ]));
                if ((typeof context.get('_seq') === 'object') && this.isCountable(context.get('_seq'))) {
                    let length = this.count(context.get('_seq'));
                    let loop = context.get('loop');
                    loop.set('revindex0', length - 1);
                    loop.set('revindex', length);
                    loop.set('length', length);
                    loop.set('last', (length === 1));
                }
                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`i`] = __value__;
                    this.echo(`      `);
                    this.echo(this.include(context, this.source, this.loadTemplate(`e968fcb08ec832e1a1295316e3e5c05881627562090baf8760cd67f88b5cf595`, `e968fcb08ec832e1a1295316e3e5c05881627562090baf8760cd67f88b5cf595`, 12, 22), undefined, true, false, 12));
                    this.echo(`    `);
                    (() => {
                        let loop = context.get('loop');
                        loop.set('index0', loop.get('index0') + 1);
                        loop.set('index', loop.get('index') + 1);
                        loop.set('first', false);
                        if (loop.has('length')) {
                            loop.set('revindex0', loop.get('revindex0') - 1);
                            loop.set('revindex', loop.get('revindex') - 1);
                            loop.set('last', loop.get('revindex0') === 0);
                        }
                    })();
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('i');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`  `);
            }

            getTemplateName() {
                return `e968fcb08ec832e1a1295316e3e5c05881627562090baf8760cd67f88b5cf595`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e968fcb08ec832e1a1295316e3e5c05881627562090baf8760cd67f88b5cf595`, ``);
            }
        }],
        [22, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/media/media.twig`, `e968fcb08ec832e1a1295316e3e5c05881627562090baf8760cd67f88b5cf595`, 12);

                this.blocks = new Map([
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/media/media.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          `);
                this.echo(this.include(context, this.source, `@cloudfour/components/avatar/avatar.twig`, new Map([[`src`, (`https://api.lorem.space/image/face?w=120&h=120&t=` + this.traceableMethod(this.getAttribute, 15, this.source)(this.env, (context.has(`loop`) ? context.get(`loop`) : null), `index`, new Map([]), `any`, false, false, false))], [`sizes`, `60px`]]), false, false, 14));
                this.echo(`        `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          <p>
            `);
                this.echo(this.env.getFilter('escape').traceableCallable(21, this.source)(...[this.env, this.env.getFilter('slice').traceableCallable(21, this.source)(...[this.env, `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque eu ex enim. Nunc efficitur scelerisque dolor et sollicitudin. Donec finibus lorem elit, eu consectetur quam pellentesque sed. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.`, 0, (this.traceableMethod(this.getAttribute, 21, this.source)(this.env, (context.has(`loop`) ? context.get(`loop`) : null), `index`, new Map([]), `any`, false, false, false) * 50)]), `html`, null, true]));
                this.echo(`
          </p>
        `);
            }

            getTemplateName() {
                return `e968fcb08ec832e1a1295316e3e5c05881627562090baf8760cd67f88b5cf595`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e968fcb08ec832e1a1295316e3e5c05881627562090baf8760cd67f88b5cf595`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'e968fcb08ec832e1a1295316e3e5c05881627562090baf8760cd67f88b5cf595');

let template = env.loadTemplate('e968fcb08ec832e1a1295316e3e5c05881627562090baf8760cd67f88b5cf595');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/deck/demo/alignment.twig", args: context }
     );
     return rendered;;
};